import createStore from 'webmd-cms-store/src/store';

export default createStore;
